import router from 'next/router';

export const BANNER = {
  title: '支持与帮助',
  content:
    'StreamLake 提供完善且专业的技术咨询服务及业务咨询服务，助力客户成功',
};

export const CONFIG_DESC = [
  {
    icon: '/img/support-help/supportIcon1.webp',
    title: '咨询电话',
    desc: ['24小时服务热线：400-104-6212'],
    hasBtn: false,
    btnDesc: '',
  },
  {
    icon: '/img/support-help/supportIcon3.webp',
    title: '技术工单',
    desc: ['智能化排障与归因、高效问题定位与反馈'],
    hasBtn: false,
    // btnDesc: '提交工单',
  },
  {
    icon: '/img/support-help/supportIcon2.webp',
    title: '投诉与建议',
    desc: ['主动聆听客户声音、快速响应客户诉求，产品专家及时解答您的疑问'],
    hasBtn: true,
    btnDesc: '立即反馈',
    onClick: () => router.push('/form/feedback'),
  },
];
export const NOTICE_DESC = [
  {
    desc: '敬请期待……',
  },
];
